// import cyQyManageList from '../components/manageCy/cyQyManageList.vue'
// import supplierListCy from '../components/manageCy/supplierListCy.vue'
// import viewCyQyManage from '../components/manageCy/viewCyQyManage.vue'
// import viewSupplierCy from '../components/manageCy/viewSupplierCy.vue'

export default [
    {
        path: 'manageCy/cyQyManageList',
        component: resolve => require(['@/components/manageCy/cyQyManageList'],resolve),
        name:"CyQyManageList",
        meta:{
            id:'654',
            node:'manageCy',
            url:'cyQyManageList',
        }
    },
    {
        path: 'manageCy/supplierListCy',
        component: resolve => require(['@/components/manageCy/supplierListCy'],resolve),
        name:"SupplierListCy",
        meta:{
            id:'656',
            node:'manageCy',
            url:'supplierListCy',
        }
    },
    {
        path: 'manageCy/viewCyQyManage',
        component: resolve => require(['@/components/manageCy/viewCyQyManage'],resolve),
        name:"ViewCyQyManage",
        meta:{
            id:'655',
            node:'manageCy',
            url:'viewCyQyManage',
        }
    },
    {
        path: 'manageCy/viewSupplierCy',
        component: resolve => require(['@/components/manageCy/viewSupplierCy'],resolve),
        name:"ViewSupplierCy",
        meta:{
            id:'658',
            node:'manageCy',
            url:'viewSupplierCy',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/manageCy.js